import { ACCESS_ROLES } from 'src/config';

export const isAdminOrSiteManager = (currentRole: string) => {
  const isSuperAdmin = currentRole === ACCESS_ROLES.SUPER_ADMIN;
  const isAccountAdmin = currentRole === ACCESS_ROLES.ACCOUNT_ADMIN;
  const isSiteManager = currentRole === ACCESS_ROLES.SITE_MANAGER;
  return !(isSuperAdmin || isAccountAdmin || isSiteManager);
};
